<div class="control-card-header">
  <ng-container i18n="@@accessMethodGuide_title">Inserimento codici:</ng-container>
  <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
</div>

<div class="control-card-content">
  <p i18n="@@accessMethodGuide_phone">Telefono: Inserire il numero di telefono, prefisso escluso</p>

  <p i18n="@@accessMethodGuide_car">Auto : Inserire la targa del veicolo</p>

  <p i18n="@@accessMethodGuide_remote1c"> Radiocomando 1Control: Inserire il codice presente sull'etichetta posta sul
    retro del radiocomando</p>

  <p i18n="@@accessMethodGuide_remote"> Radiocomando JCM: Inserire il codice a 5 o 6 cifre riportato sull'etichetta
    posteriore
    (vedesi immagine)</p>

  <img src="assets/img/jcm-codes.png" class="image-center">

  <br>
  <br>

  <a (click)="closeDialog()" class="button user-add-button">
    <ng-container i18n="@@accessMethodGuide_ok">OK</ng-container>
  </a>

</div>
